// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Yz-z","tooltipWrapper":"Zz-z","icon":"_z-z","tooltip":"aA-z","content":"bA-z"};